import script from "./MyAchievements.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAchievements.vue?vue&type=script&setup=true&lang=js"

import "./MyAchievements.vue?vue&type=style&index=0&id=54275cbc&scoped=true&lang=css"
import "./MyAchievements.vue?vue&type=style&index=1&id=54275cbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54275cbc"]])

export default __exports__